import React from 'react';
import { useGoBack } from './routing/useGoBack';
import { useGetClosestHandle } from './routing/useGetClosestHandle';
import { ChevronLeft, type LucideIcon } from 'lucide-react';
import { Button } from './components/buttons/Button';

export interface PageHeaderProps {
	title: string;
	statusSlot?: React.ReactNode;
	description?: string | React.ReactNode;
	backUrl?: string;
	TitleIcon?: LucideIcon;
	titleRightSlot?: React.ReactNode;
}

export function PageHeader({ title, statusSlot, description, backUrl, TitleIcon, titleRightSlot }: PageHeaderProps) {
	const routeHandle = useGetClosestHandle<{ disableBack?: boolean }>();
	const goBack = useGoBack(backUrl);
	const disableGoBack = routeHandle?.disableBack ?? false;

	return (
		<div className="flex h-[62px] items-center justify-between gap-4 border-b border-gray-100 bg-white px-5 py-3">
			<div className="flex items-center gap-3">
				{!disableGoBack && (
					<Button Icon={ChevronLeft} aria-label="Back" onClick={goBack} intent="neutralLight" appearance="ghost" size="xs" />
				)}
				<div className="flex items-center gap-2.5">
					<h1 className="font-bold text-gray-900">{title}</h1>
					{statusSlot}
				</div>
				{description && <span className="text-sm text-gray-500">{description}</span>}
			</div>
			{titleRightSlot}
		</div>
	);
}
